export default __webpack_public_path__ + "static/Montserrat-Black-08437fd0aa82576d3678eca3a2bf3d7e.ttf";